import { render, staticRenderFns } from "./CadastroPlantasPicker.vue?vue&type=template&id=5684b1c5&lang=pug&"
import script from "./CadastroPlantasPicker.vue?vue&type=script&lang=js&"
export * from "./CadastroPlantasPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports